import { useHypertune } from '../generated/hypertune.react';
import useQueryParams from './useQueryParams';

const useEnableHecEmergencyBanner = () => {
  const { useHecEmergencyBanner } = useQueryParams();

  const hypertune = useHypertune();

  if (useHecEmergencyBanner === 'false') {
    return false;
  }

  return (
    hypertune.enableHECEmergencyBanner({ fallback: false }) ||
    useHecEmergencyBanner === 'true'
  );
};

export default useEnableHecEmergencyBanner;
